<template>
  <v-app>
    <v-container class="appContainer appgrid px-0 pt-0" style="background:#efefef;" fluid>
      <AppNavigation/>
      <v-main v-if="loggedIn" class="mainContent">
        <router-view></router-view>
      </v-main>
    <div class="appFooter">
    </div>
  </v-container>
  <AppFooter/>
  </v-app>
</template>

<script>
import { Auth } from 'aws-amplify'
import { mapActions, mapGetters, mapState } from 'vuex'
import AppNavigation from './components/AppNavigation.vue'
import AppFooter from './components/AppFooter'

export default {
  name: 'App',
  components: {
    AppNavigation,
    AppFooter
  },
  data: () => ({}),
  computed: {
    ...mapState(['loggedIn']),
    ...mapGetters({
      getAuthToken: 'account/authToken',
      getCurrentUser:'account/getCurrentLoggedInUser'
    })
  },
  async mounted () {
    this.$watch(() => this.loggedIn && this.getCurrentUser && this.getCurrentUser.username,
    () => {
      if(this.loggedIn && this.getCurrentUser && this.getCurrentUser.username){
        this.fetchPriceSources()
        this.fetchUserByUsername({username:this.getCurrentUser.username.split('_')[1]})
        this.fetchSportTypes()
      }
    })
    try {
      var sessionActive = await Auth.currentSession()
      if(Object.keys(sessionActive).length > 0) {
        this.authState(true)
      }
    } catch {
      await Auth.signOut()
      this.authState(false)
    }
  },
  methods: {
    ...mapActions(['authState', 'fetchSportTypes', 'fetchPriceSources','fetchUserByUsername']),
   ...mapActions('account', ['fetchUser']),
  },
  async created () {
    // this.fetchSportTypes()
    this.$vuetify.theme.themes.light.primary = '#1A237E'
    await this.fetchUser()
  }
}
</script>

<style>
.container {
  padding:0px;
}
.doApp {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                      supported by Chrome, Edge, Opera and Firefox */
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0;
}

.appHeaderGrid {
  grid-area: header;
  align-self: start;
  grid-column-start: first;
  grid-column-end: 3;
}

.appOddsGrid {
  grid-area: main;
  align-self: stretch;
  grid-column-start: first;
  grid-column-end: 2;
}
/* width */
::-webkit-scrollbar {
  width: 7px;
  height:7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

</style>

